import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 600px;
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  background: linear-gradient(135deg, #022069, #0336a6);
  border-radius: 16px;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  overflow: hidden;
  position: relative;
  box-shadow: 0 10px 30px rgba(2, 32, 105, 0.3);

  &::before {
    content: '';
    position: absolute;
    top: -50px;
    right: -20px;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(6,182,212,0.5) 0%, transparent 70%);
    opacity: 0.6;
    pointer-events: none;
  }

  @media(max-width: 600px) {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
`;

const Content = styled.div`
  flex: 1;
  h3 { margin: 0 0 10px 0; font-size: 24px; font-weight: 900; }
  p { margin: 0 0 20px 0; color: rgba(255,255,255,0.8); line-height: 1.5; }
`;

const Badges = styled.div`
  display: flex;
  gap: 15px;
  
  img {
    height: 40px;
    cursor: pointer;
    transition: transform 0.2s;
    &:hover { transform: translateY(-3px); }
  }

  @media(max-width: 600px) {
    justify-content: center;
  }
`;

const PhoneMockup = styled.div`
  width: 120px;
  height: 200px;
  background: var(--glass-1);
  border: 4px solid #fff;
  border-radius: 20px;
  margin-right: -20px;
  margin-bottom: -60px;
  position: relative;
  z-index: 2;
  box-shadow: -10px 10px 20px rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent);
  font-weight: bold;
  font-size: 24px;

  &::after {
    content: '';
    position: absolute;
    top: 5px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 4px;
    background: #fff;
    border-radius: 2px;
  }

  @media(max-width: 600px) {
    margin: 0;
    height: 150px;
    width: 100px;
  }
`;

const AppDownloadWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <Content>
        <h3>{node.content?.title || 'Die Mein O₂ App'}</h3>
        <p>{node.content?.desc || 'Volle Vertragsübersicht, exklusive Priorities und Geschenke direkt auf deinem Smartphone.'}</p>
        <Badges>
          <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="App Store" />
          <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" />
        </Badges>
      </Content>
      <PhoneMockup>O₂</PhoneMockup>
    </Wrapper>
  );
};

registry.register('app_download', {
  label: 'App Download',
  icon: '📱',
  category: 'tef_specific',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: AppDownloadWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Inhalt', fields: [{name:'content.title', label:'Titel', type:'text'}, {name:'content.desc', label:'Beschreibung', type:'textarea'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}, {name:'style.desktop.width', label:'Breite', type:'text'}] }] }
  ]
});
